<template>
	<div class="drag-handler">
		<span></span>
		<span></span>
		<span></span>
	</div>
</template>
<script>
export default {
	name: 'PDragHandle',
};
</script>

<style lang='scss' scoped>
.drag-handler {
	height: 20px;
	cursor: move;
	padding-right: 5px;
	margin-right: 10px;
	span {
		display: flex;
		height: 6px;
		justify-content: center;
		align-items: center;
		&:before, &:after {
			content: '';
			width: 3px;
			height: 3px;
			background-color: var(--app-color-gray);
			display: inline-block;
			border-radius: 50%;
		}
		&:before {
			margin-right: 4px;
		}
		&:after {
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-drag-handler.vue